/*
    Copyright (c) Computer-L.A.N. GmbH (http://www.computer-lan.de).
    Alle Rechte vorbehalten.
*/

import useT, {
    UseTranslationOptions,
} from "../../../Basis/Internationalisierung/Hooks/useTranslation";
import i18n from "../../../Basis/Internationalisierung/i18n";

export const useTranslation = (options?: UseTranslationOptions) => useT("i18nSupport", options);
export const fixedT = i18n.getFixedT(null, "i18nSupport");

export const translationKeys = {
    appHelp: {
        fragenUndAntworten: "appHelp.fragenUndAntworten",
        oeffneVerbesserungsvorschlag: "appHelp.oeffneVerbesserungsvorschlag",
        oeffneRoadmap: "appHelp.oeffneRoadmap",
        oeffneKontaktformular: "appHelp.oeffneKontaktformular",
        neuigkeiten: "appHelp.neuigkeiten",
        ueber: "appHelp.ueber",
        support: "appHelp.support",
        infos: "appHelp.infos",
        hilfeLabel: "appHelp.hilfeLabel",
        hilfeTitel: "appHelp.hilfeTitel"
    },
    kontaktformularDialog: {
        dialogTitel: "kontaktformularDialog.dialogTitel",
        dialogText: "kontaktformularDialog.dialogText",
        betreff: "kontaktformularDialog.betreff",
        text: "kontaktformularDialog.text",
        senden: "kontaktformularDialog.senden",
        abbrechen: "kontaktformularDialog.abbrechen",
    },
};
